var _effectorFileName = "/builds/gmini/front-common/src/forge-viewer/model/selectModel.ts";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import { combine, createEvent, restore } from 'effector';
var viewerShowModeDescription = {
  ShowAll: 'Показывать все',
  Hide: 'Скрыть невыбранные',
  Isolate: 'Прозрачность'
};
var resetMultiplySelect = createEvent({
  name: "resetMultiplySelect",
  sid: "-osn364"
});
var selectMultiply = createEvent({
  name: "selectMultiply",
  sid: "leoujs"
});
var changeViewerMode = createEvent({
  name: "changeViewerMode",
  sid: "dxj1t6"
});
var resetShowMode = createEvent({
  name: "resetShowMode",
  sid: "9olut2"
});
var showElementsInViewer = createEvent({
  name: "showElementsInViewer",
  sid: "ld26p5"
});
var multiplyViewerSelect$ = restore(selectMultiply, null, {
  name: "multiplyViewerSelect$",
  sid: "-6rdwrk"
});
var showInViewerMode$ = restore(changeViewerMode, 'ShowAll', {
  name: "showInViewerMode$",
  sid: "-nq9tdd"
}).reset(resetShowMode);
combine({
  ɔ: [{
    multiplyViewerSelect: multiplyViewerSelect$,
    viewerShowMode: showInViewerMode$
  }, function (_ref) {
    var multiplyViewerSelect = _ref.multiplyViewerSelect,
        viewerShowMode = _ref.viewerShowMode;
    return {
      multiplyViewerSelect: multiplyViewerSelect,
      viewerShowMode: viewerShowMode
    };
  }],
  config: {
    sid: "-a7jruq"
  }
}).watch(function (_ref2) {
  var multiplyViewerSelect = _ref2.multiplyViewerSelect,
      viewerShowMode = _ref2.viewerShowMode;

  if (!multiplyViewerSelect) {
    showElementsInViewer({
      mode: 'ShowAll',
      selectedElements: {}
    });
  } else {
    showElementsInViewer({
      mode: viewerShowMode,
      selectedElements: multiplyViewerSelect.reduce(function (acc, _ref3) {
        var externalIds = _ref3.externalIds,
            viewerId = _ref3.viewerId;
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, viewerId, externalIds));
      }, {})
    });
  }
});
export { showElementsInViewer, selectMultiply, changeViewerMode, resetShowMode, multiplyViewerSelect$, showInViewerMode$, viewerShowModeDescription, resetMultiplySelect };